/** Gate pass permission strings (mirror backend PermissionCatalog). */
export const GatePassPermissions = {
  selfRequest: 'gate_pass_self_request',
  approve: 'gate_pass_approve',
  issue: 'gate_pass_issue',
} as const
